module.exports = __webpack_public_path__ + "media/images/sprite/ico-facebook-d9660c90629e6b8b17859de27de00911.png";